import { GridCellParams, GridRowModel } from "@mui/x-data-grid-premium";
import React from "react";

/**
 * For some columns we use all data in the row to calculate the value.
 * This will try to do the same for the aggregate row.
 * This func checks if a "row" object is the aggregate row.
 */
const isRowAggregationRow = (row: GridRowModel) => {
  if (Object.keys(row).length === 0) return true;
  return false;
};

// Wrapper function that guards against rendering the aggregate row.
export const RequireNonAggregationRow =
  <Params extends GridCellParams>(
    renderCell: (params: Params) => React.ReactNode | null
  ): ((params: Params) => React.ReactNode | null) =>
  (params) => {
    if (isRowAggregationRow(params.row as GridRowModel)) {
      return null;
    }
    return renderCell(params);
  };
